var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"rkm-container",attrs:{"fluid":_vm.fluid}},[(_vm.noCard)?[_vm._t("default")]:_c('rkm-card',{attrs:{"no-body":_vm.noBody}},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }